export function userFullName(data) {
  return `${data.firstName || ''} ${data.lastName || ''} ${data.middleName || ''}`
}
